import {
  PROGRAM_ENROLLMENTS_GET_URL,
  PROGRAM_ENROLLMENTS_POST_URL
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

export const getProgramEnrollments = associationsNum => (dispatch, getState) =>
  asyncRequest({
    url: PROGRAM_ENROLLMENTS_GET_URL(associationsNum),
    successAction: data => ({
      type: types.GET_PROGRAM_ENROLLMENTS_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.GET_PROGRAM_ENROLLMENTS_FAILURE,
      payload: error
    }),
    dispatch
  });

export const postProgramEnrollments = payloadBody => (dispatch, getState) =>
  asyncRequest({
    url: PROGRAM_ENROLLMENTS_POST_URL(),
    method: 'POST',
    data: payloadBody,
    successAction: data => ({
      type: types.POST_PROGRAM_ENROLLMENTS_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.POST_PROGRAM_ENROLLMENTS_FAILURE,
      payload: error
    }),
    dispatch
  });
export const resetReduxState = key => ({
  type: 'RESET_KEY',
  payload: { key }
});
